"use client";

import { useEffect, useEffectEvent, useRef } from "react";

export function useHydrateOnce<Source>(
  source: Source | null | undefined,
  hydrate: (source: Source) => void,
): void {
  const hydratedRef = useRef(false);
  const applyHydration = useEffectEvent(hydrate);

  useEffect(() => {
    if (hydratedRef.current || source === null || source === undefined) return;
    hydratedRef.current = true;
    applyHydration(source);
  }, [source]);
}
